module.exports = __webpack_public_path__ + "static/media/web logos_FTL.b28b3d74.jpg";